export const removeLastItemFromBreadCrumb = (array) => {
  // Check if the input is an array and not empty
  if (!Array.isArray(array) || array.length === 0) {
    return [];
  }
  // Create a shallow copy of the array without the last item
  return array.slice(0, -1);
};

/**
 * Checks if a value is numeric and should be formatted
 * @param {*} value - The value to check
 * @returns {boolean} - True if value should be formatted as a number
 */
export const isNumericValue = (value) => {
  // Skip null, undefined, empty strings
  if (value === null || value === undefined || value === '') {
    return false;
  }

  // Skip if it's already formatted HTML or contains HTML tags
  if (typeof value === 'string' && (value.includes('<') || value.includes('http'))) {
    return false;
  }

  // Check if it's a valid number
  const num = Number(value);
  return !isNaN(num) && isFinite(num);
};

/**
 * Formats a number with commas and 2 decimal places
 * @param {number|string} value - The number to format
 * @returns {string|*} - Formatted number (e.g., "1,234.56") or original value
 */
export const formatNumber = (value) => {
  // Return original value if it's not numeric
  if (!isNumericValue(value)) {
    return value;
  }

  const num = Number(value);
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
